export default () => {
    return {
        call_intercom: ({ command, event_type, props }) => {
            if (window.Intercom) {
                if (event_type)
                    window.Intercom(command, event_type, props)
                else
                    window.Intercom(command, props)
            }
        }
    }
}